export const safeReturnPath = value => {
  if (typeof value !== "string" || value.length > 1500) return "/";
  let decoded;
  try { decoded = decodeURIComponent(value); } catch { return "/"; }
  for (const path of [value, decoded]) {
    if (!path.startsWith("/") || path.startsWith("//") || /[\\\u0000-\u001f\u007f]/.test(path)) return "/";
    if (["/signin", "/signup", "/auth/google"].includes(path.split(/[?#]/)[0])) return "/";
  }
  return value;
};